export default "__VITE_ASSET__DmDYbi38__";